/**
 * Feature flags — read from NEXT_PUBLIC_TF_* env vars.
 * Set to "true" in .env.local (or staging env) to enable.
 */

export const TF_RECRUITER_REMOVAL =
  process.env.NEXT_PUBLIC_TF_RECRUITER_REMOVAL?.trim().toLowerCase() === "true";

export const TF_SHOW_NEW_UI_LANDING_PAGE =
  process.env.NEXT_PUBLIC_TF_SHOW_NEW_UI_LANDING_PAGE?.trim().toLowerCase() === "true";

export const TF_VIDEO_INTERVIEW_ENABLED =
  process.env.NEXT_PUBLIC_TF_VIDEO_INTERVIEW_ENABLED?.trim().toLowerCase() === "true";

export const TF_ENABLE__VIDEO_INTERVIEW_FOR_USER =
  process.env.NEXT_PUBLIC_TF_ENABLE__VIDEO_INTERVIEW_FOR_USER?.trim().toLowerCase() === "true";

// Payment gateway selection: "payu" (default) or "cashfree".
// When unset or set to "payu", the existing PayU flow is used unchanged.
export const PAYMENT_GATEWAY =
  process.env.NEXT_PUBLIC_PAYMENT_GATEWAY?.trim().toLowerCase() || "payu";
